import React from 'react';

// === Components === //
import Container from '@components/common/Container';
import MultilineListItem from '@components/sections/components/MultilineListItem';

interface MultiLineProps {
  data: ItemData[];
}

interface ItemData {
  alt: string;
  url: string;
  text: string;
  id: string;
}

const MultiLine = ({ data }: MultiLineProps) => {
  return (
    <Container>
      <>
        {data.map((item) => (
          <MultilineListItem key={item.id} {...item} />
        ))}
      </>
    </Container>
  );
};

export default MultiLine;
